const SearchUrl = '/search';

export default SearchUrl;
